import { CreateAndUpdateProfessionalScheduleRequestDTO } from '../../dtos/CreateProfessionalScheduleDTO';
import { ProfessionalSchedule } from '../../entities/ProfessionalSchedule';
import { api } from '../api';

export const createProfessionalSchedule = async ({
  createdUpdatedBy,
  professionalId,
  professionalScheduleAvailabilitiesData,
  scheduleCustomType,
}: CreateAndUpdateProfessionalScheduleRequestDTO): Promise<ProfessionalSchedule> => {
  const { data } = await api.post('/professionalSchedule', {
    createdUpdatedBy,
    professionalId,
    professionalScheduleAvailabilitiesData,
    scheduleCustomType,
  });

  return data;
};
